import { Button, Form, Input, Modal, Select, Table, message } from "antd";
import DataTable, { DataItemAction, DataTableRef } from "../../common/components/DataTable"
import EditableCell from "../../common/components/EditableCell";
import useInfraccionesInfractoresAPI, { InfraccionesInfractor } from "../../infracciones-infractores/useInfraccionesInfractoresAPI"
import { FilterValue } from "antd/lib/table/interface";
import DataFilter from "../../common/components/DataFilter";
import { useContext, useEffect, useRef, useState } from "react";
import InfraccionesConvenioList from "./InfraccionesInfractorList";
import { Infraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import useConveniosPagoAPI, { ConvenioPago, ConvenioPagoConfiguracion, MontosConvenio, NuevoConvenioRequest } from "../useConveniosPagoAPI";
import PreviewConvenio from "./PreviewConvenio";
import { useForm } from "antd/lib/form/Form";
import UsuariosContext from "../../common/contexts/UsuariosContext";
//import useUsuariosAPI, { LoginData, LoginResponse, usrConfig } from "../../usuarios/useUsuariosAPI";
import { ActionResult } from "../../common/hooks/useApi";

export default () => {
    const api = useConveniosPagoAPI();
    //const apiUSR = useUsuariosAPI();
    const [cuitCuilFilterForm] = Form.useForm();
    const [nombreCompletoForm] = Form.useForm();
    const [selectedInfractor, setSelectedInfractor] = useState<InfraccionesInfractor>()
    const [selectedInfracciones, setSelectedInfracciones] = useState<Infraccion[]>([])
    const [selectedInfraccionesIds, setSelectedInfraccionesIds] = useState<number[]>([])
    const [montosConvenio, setMontosConvenio] = useState<MontosConvenio>()
    const [convenioForm] = useForm()
    const [loading, setLoading] = useState(false);
    const [mostrarVigentes, setMostrarVigentes] = useState(false)
    const tableRef = useRef<DataTableRef>(undefined!)
    const [descuentosResponse, setDescuentos] = useState<ActionResult<ConvenioPagoConfiguracion>>();
    const usuariosContext = useContext(UsuariosContext);

    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.InfractorCuitCuil != null ? `contains(InfractorCuitCuil,'${filters!.InfractorCuitCuil![0]}')` : "",
            filters?.InfractorNombreCompleto != null ? `contains(InfractorNombreCompleto,'${filters!.InfractorNombreCompleto![0]}')` : "",
            filters?.InfractorTipo != null ? `InfractorTipo eq '${filters!.InfractorTipo![0]}'` : "",
        ];
    }


    useEffect(() => {
        //ConvenioPagoDescuentos
        api.getDescuentos().then(setDescuentos)
    }, [])

    const itemActions: DataItemAction<InfraccionesInfractor>[] = [
        {
            key: 'list-infracciones-vencidas',
            action(item, selectedItems) {
                setSelectedInfracciones([]);
                setSelectedInfractor(item);
                setMostrarVigentes(false);
            },
            label: "Ver infracciones vencidas"
        },
        {
            key: 'list-infracciones-vigentes',
            action(item) {
                setSelectedInfracciones([]);
                setSelectedInfractor(undefined);
                setSelectedInfractor(item);
                setMostrarVigentes(true);
            },
            label: "Ver infracciones vigentes"
        },
    ];


    const previewConvenio = async () => {
        setLoading(true)
        const nuevoConvenio: NuevoConvenioRequest = {
            CantidadCuotas: convenioForm.getFieldsValue().selectedCuotas,
            CuitCuilTitular: selectedInfractor!.InfractorCuitCuil,
            IdsInfracciones: selectedInfraccionesIds,//selectedInfracciones.map(i => i.Id),
            PorcentajeDescuento: convenioForm.getFieldsValue().selectedDiscount
        }
        try {
            const response = await api.getMontos(nuevoConvenio, mostrarVigentes);

            if (response.error) throw new Error()

            setMontosConvenio(response.data!.value)
        }
        catch {
            message.error({
                content: 'Error al previsualizar el convenio'
            });
        }


        setLoading(false)
    }

    const generateConvenio = async () => {
        setLoading(true)
        const nuevoConvenio: NuevoConvenioRequest = {
            // CantidadCuotas: 1,
            CantidadCuotas: convenioForm.getFieldsValue().selectedCuotas,
            CuitCuilTitular: selectedInfractor!.InfractorCuitCuil,
            IdsInfracciones: selectedInfraccionesIds,//selectedInfracciones.map(i => i.Id),
            PorcentajeDescuento: convenioForm.getFieldsValue().selectedDiscount
        }
        try {
            const response = await api.generar(nuevoConvenio, mostrarVigentes)
            if (response.error) throw new Error()

            const urlResponse = await api.pdfDownload(response.data!)
            if (urlResponse.error) throw new Error()

            const url = urlResponse.data!
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `convenio-${response.data!}.pdf`);
            document.body.appendChild(link);
            link.click();

            setMontosConvenio(undefined)
            setSelectedInfractor(undefined)
            tableRef.current.loadItems()
        }
        catch {
            message.error({
                content: 'Error al generar el convenio'
            });
        }


        setLoading(false)
    }


    return (
        <>
            <DataTable<InfraccionesInfractor, InfraccionesInfractor>
                list={api.listInfraccionesInfractor}
                defaultPageSize={10}
                generateFilters={generateFilters}
                defaultSortOrder={"CantidadInfracciones desc"}
                title="Infractores con infracciones adeudadas"
                itemActions={itemActions}
                ref={tableRef}
                keepSelectionBetweenPages={true}
            >
                <Table.Column<InfraccionesInfractor>
                    width={`35%`}
                    title="Nombre completo"
                    dataIndex={"InfractorNombreCompleto"}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreCompletoForm} >
                                <Form.Item name={"NombreCompleto"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Nombre completo...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                    sorter
                    render={(val, record) => record.InfractorNombreCompleto}
                    sortDirections={["ascend", "descend", "ascend"]}

                />

                <Table.Column<InfraccionesInfractor>
                    width={`30%`}
                    title="CUIT/CUIL"
                    dataIndex={"InfractorCuitCuil"}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={cuitCuilFilterForm} >
                                <Form.Item name={"CuitCuil"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='CUIT/CUIL...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                    sorter
                    render={(val, record) => record.InfractorCuitCuil}
                    sortDirections={["ascend", "descend", "ascend"]}

                />


                <Table.Column<InfraccionesInfractor>
                    width={`10%`}
                    title="Tipo"
                    dataIndex={"InfractorTipo"}
                    sorter
                    render={(val, record) => record.InfractorTipo}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={cuitCuilFilterForm} >
                                <Form.Item name={"Tipo"} style={{ marginBottom: 10 }}>
                                    <Select placeholder="Tipo de infractor...">
                                        <Select.Option key="1" value={'EMPRESA'}>Empresa</Select.Option>
                                        <Select.Option key="2" value={'MASCULINO'}>Masculino</Select.Option>
                                        <Select.Option key="3" value={'FEMENINO'}>Femenino</Select.Option>
                                        <Select.Option key="4" value={'OTRO'}>Otro</Select.Option>
                                    </Select>
                                </Form.Item>
                            </DataFilter>
                        );
                    }}
                    sortDirections={["ascend", "descend", "ascend"]} />


                <Table.Column<InfraccionesInfractor>
                    width={`10%`}
                    title="Impagas"
                    dataIndex={"CantidadInfracciones"}
                    sorter
                    defaultSortOrder={"descend"}
                    render={(val, record) => record.CantidadInfracciones}
                    sortDirections={["ascend", "descend", "ascend"]}

                />
            </DataTable>

            {/* Generar convenio */}
            <Modal

                width={"90%"}
                style={{ maxWidth: "768px" }}
                bodyStyle={{ maxHeight: "500px", overflow: "auto" }}
                title={"Datos del convenio"}
                visible={montosConvenio !== undefined}
                okText="Generar convenio"
                confirmLoading={loading}
                cancelButtonProps={{
                    disabled: loading
                }}
                onOk={() => generateConvenio()}
                onCancel={() => setMontosConvenio(undefined)}
                cancelText="Cancelar"
            >

                {montosConvenio && <PreviewConvenio montos={montosConvenio} cuotas={convenioForm.getFieldsValue().selectedCuotas} />}
            </Modal>

            {/* Previsualizar convenio */}
            <Modal
                width={"90%"}
                style={{ maxWidth: "1200px" }}
                bodyStyle={{ maxHeight: "500px", overflow: "auto" }}
                title={`Infracciones de ${selectedInfractor?.InfractorNombreCompleto} (${selectedInfractor?.InfractorCuitCuil})`}
                open={selectedInfractor !== undefined}
                onCancel={() => setSelectedInfractor(undefined)}

                footer={[
                    <div style={{ display: "flex", justifyContent: 'end' }}>
                        <Form
                            form={convenioForm}
                            onFinish={() => previewConvenio()}
                            layout="inline">
                            <Form.Item
                                required
                                name={"selectedDiscount"}
                                rules={[{ required: true, message: "Seleccione el descuento" }]}
                                label="Porcentaje de descuento">

                                <Select style={{ minWidth: "100px" }} >
                                    {descuentosResponse?.data?.value.porcentajes.map((u) => (
                                        <Select.Option key={u} value={u}>
                                            {u} %
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                             <Form.Item
                                name={"selectedCuotas"}
                                rules={[{ required: true, message: "Seleccione el número de cuotas" }]}
                                label="Número de cuotas">

                                <Select style={{ minWidth: "100px" }} defaultValue={1}>
                                    <Select.Option value={1}>1</Select.Option>
                                    <Select.Option value={2}>2</Select.Option>
                                    <Select.Option value={3}>3</Select.Option>
                                </Select>
                            </Form.Item>
                        </Form>
                        <Button disabled={loading} onClick={() => setSelectedInfractor(undefined)}>Cancelar</Button>
                        <Button

                            loading={loading}
                            onClick={() => convenioForm.submit()}
                            type="primary">{selectedInfraccionesIds.length == 0 ? "Previsualizar Convenio (todas)" : "Previsualizar Convenio (seleccionadas)"}
                        </Button>
                    </div>
                ]}
            >
                {selectedInfractor &&
                    <InfraccionesConvenioList
                        onInfraccionesSelectionChanged={(i) => {
                            setSelectedInfracciones(i)
                        }}
                        setSelectedInfraccionesIds={setSelectedInfraccionesIds}
                        CuitCuil={selectedInfractor.InfractorCuitCuil}
                        mostrarVigentes={mostrarVigentes} />}
            </Modal>
        </>
    )
}
